import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import BarChart from 'components/BarChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByBin
 * @desc Render % of Chargebacks by BIN (Top N) chart
 * @filterValues IReportsFilter
 */
const ByBin = ({
    filterValues,
    topN = 5,
}: {
    filterValues: IReportFilter
    topN?: number
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ name: string; value: number }[]>([])

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByIssuer(filterValues, topN).then((data) => {
            setLoading(false)
            // removes the 'Others' data object from the chart data
            const topNIssuers = data.filter((bin: any) => bin.name !== 'Others')

            setData(topNIssuers)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    const colorPalette = clientTheme.charts.barCharts.byBinBarChart.fill

    return (
        <AccentArea title={`% of Chargebacks by BIN (Top ${topN})`}>
            <BarChart
                data={data}
                loading={loading}
                valueDataKey="value"
                barLineColor={colorPalette}
                dataValuePercent
                showLegend={false}
                tooltipPercent
                disableAutoDomain
                //Remove if no showLegend
                // height={280}
            />
        </AccentArea>
    )
}

export default ByBin
